export default "__VITE_ASSET__COSxOEKp__"